// @flow
import {
  IFRAME_SOURCE_ID,
  IFRAME_ACTION_NAVIGATE,
  IFRAME_ACTION_CLOSE,
  IFRAME_ACTION_ADDTOSLIP,
  IFRAME_ACTION_ANALYTICS,
  EVENT_PAGE,
  HOME_PAGE,
  SPORTCALLER_ANALYTICS_EVENT,
  PAGEVIEW_ANALYTICS_EVENT,
} from '../constants'
import { getMessageBus, topics } from '../apis'
import { getBetIds } from '../helpers'
import { track } from '@sb/analytics-adapter/src/client'

/*
  Type definitions
 */
type NavigateActionType = 'navigate'
type CloseActionType = 'close'
type AddToSlipActionType = 'addToSlip'
type NavigationPayload = {
  page: string,
  eventId?: string,
  sport?: string,
}
type AddToSlipPayload = {
  selections: Array<string>,
}

type DataType = {
  source: string,
  action: NavigateActionType | CloseActionType | AddToSlipActionType,
  payload: {
    [string]: any, //to be amended to allow string or array of strings
  },
}
type EventType = {
  ...MessageEvent,
  data: DataType,
}

/*
  postMessage handler dispatcher
 */
export default ({ data, origin }: EventType): void => {
  const { source, action, payload } = data
  const eventOrigin = new URL(origin).origin
  const iframeOrigin = new URL(process.env.IFRAME_SRC || '').origin

  if (eventOrigin !== iframeOrigin || source !== IFRAME_SOURCE_ID) {
    return
  }

  switch (action) {
    case IFRAME_ACTION_NAVIGATE:
      navigation(payload)
      break
    case IFRAME_ACTION_CLOSE:
      close()
      break
    case IFRAME_ACTION_ADDTOSLIP:
      addToSlip(payload)
      break
    case IFRAME_ACTION_ANALYTICS:
      analytics(payload)
      break
  }
}

/*
  Navigation Handler
 */
function navigation(payload: NavigationPayload): void {
  const messageBus = getMessageBus()
  const { page, eventId, sport } = payload
  const baseUrl = `/betting/${global.WH.sportsbook.lang}`

  if (messageBus) {
    switch (page) {
      case EVENT_PAGE:
        messageBus.publish(topics.NAVIGATE, { url: [baseUrl, sport, eventId].join('/') })
        break
      case HOME_PAGE:
        messageBus.publish(topics.NAVIGATE, { url: baseUrl })
        break
    }
  }
}

/*
  Close Handler
 */
export function close() {
  global.location.hash = ''
}

/*
  AddToSlip Handler
*/
function addToSlip(payload: AddToSlipPayload): void {
  const messageBus = getMessageBus()
  const { selections } = payload
  const betIds = selections.map(getBetIds)

  if (messageBus) {
    betIds.forEach((betId) => messageBus.publish(topics.ADDTOSLIP, betId))
  }
}

function analytics(data: any): void {
  const { EventCategory } = data

  const payload = { ...data, ProductContext: 'SportCaller' }
  const event = !!EventCategory ? SPORTCALLER_ANALYTICS_EVENT : PAGEVIEW_ANALYTICS_EVENT

  track({
    event,
    payload,
  })
}
